import type { CyanOperationalSession } from "./cyanOperationalSessionService";

import type { CyanOperationalSessionStore } from "./cyanOperationalSessionStore";

const PREFIX = "cyan:operational-session:v1:";

export class BrowserCyanOperationalSessionStore implements CyanOperationalSessionStore {
  async get(conversationId: string): Promise<CyanOperationalSession | null> {
    const raw = window.localStorage.getItem(PREFIX + conversationId);

    if (!raw) {
      return null;
    }

    try {
      return JSON.parse(raw) as CyanOperationalSession;
    } catch {
      return null;
    }
  }

  async save(conversationId: string, session: CyanOperationalSession) {
    window.localStorage.setItem(
      PREFIX + conversationId,
      JSON.stringify(session),
    );
  }

  async delete(conversationId: string) {
    window.localStorage.removeItem(PREFIX + conversationId);
  }
}
